// extracted by mini-css-extract-plugin
export default {"container":"sidebar-menu_container__1NGQu","list":"sidebar-menu_list__1esYj","one":"sidebar-menu_one__3sJom","two":"sidebar-menu_two__2p24c"};